/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CustomerOffersResponse as ModelsCustomerCustomerOffersResponse } from '../../models/Models/Customer/customer-offers-response';

export interface V4CustomersMeNotificationsNotificationIdGet$Plain$Params {
  notificationId: string;
}

export function v4CustomersMeNotificationsNotificationIdGet$Plain(http: HttpClient, rootUrl: string, params: V4CustomersMeNotificationsNotificationIdGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerCustomerOffersResponse>> {
  const rb = new RequestBuilder(rootUrl, v4CustomersMeNotificationsNotificationIdGet$Plain.PATH, 'get');
  if (params) {
    rb.path('notificationId', params.notificationId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ModelsCustomerCustomerOffersResponse>;
    })
  );
}

v4CustomersMeNotificationsNotificationIdGet$Plain.PATH = '/v4/customers/me/notifications/{notificationId}';
